import { render, staticRenderFns } from "./employment.vue?vue&type=template&id=928ba9a2&scoped=true"
import script from "./employment.vue?vue&type=script&lang=js"
export * from "./employment.vue?vue&type=script&lang=js"
import style0 from "./employment.vue?vue&type=style&index=0&id=928ba9a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928ba9a2",
  null
  
)

export default component.exports